import { z } from 'zod'
import { StrongPasswordSchema } from './auth'

/**
 * Masaüstü Veri Merkezi kurulumu — yerel firma + ilk yönetici.
 * Kurulum sihirbazı (shell) ve backend (`POST /desktop/setup`) aynı şemayı kullanır.
 */
export const DesktopSetupSchema = z.object({
  company: z.object({
    name: z.string().trim().min(2, 'Firma adı en az 2 karakter olmalıdır.').max(100),
    legalName: z.string().trim().min(2, 'Yasal unvan en az 2 karakter olmalıdır.').max(150),
    taxOffice: z.string().trim().max(100).optional(),
    taxNumber: z.string().trim().max(20).optional(),
    city: z.string().trim().max(100).optional(),
  }),
  admin: z.object({
    firstName: z.string().trim().min(2, 'Ad en az 2 karakter olmalıdır.').max(100),
    lastName: z.string().trim().min(2, 'Soyad en az 2 karakter olmalıdır.').max(100),
    email: z.string().trim().toLowerCase().email('Geçerli bir e-posta adresi giriniz.'),
    password: StrongPasswordSchema,
  }),
})

export type DesktopSetupInput = z.infer<typeof DesktopSetupSchema>
